

<div *ngIf="message">
  <ami-dialog-message [setting]="message"></ami-dialog-message>
</div>


<ami-table-actions
[settings]="table.settings"
[data]="table.data"
[actions]="table.actions"
(action)="onReciveAction($event)"
>
</ami-table-actions>

<div *ngIf="idDocument">
  <pg-transfer-detail
    [idDocument]="idDocument"
    (onHideData)="idDocument=undefined"
  >
  </pg-transfer-detail>
</div>


<ami-dialog-confirm
  [setting]="confirmSettings"
  (confirmed)="actionConfirmed($event)"
></ami-dialog-confirm>
